import { mapState } from "vuex";
import {
  Button,
  Form,
  FormItem,
  Input,
  RadioGroup,
  Radio,
  Row,
  Col,
  Select,
  Option,
} from "element-ui";
import { omit } from "lodash";
import isMobile from "@/shared/utils/isMobile";
import FollowSignalDrawer from "@/views/pages/SignalDetail/ShareLink/ShareLinkDetail/FollowSignalDrawer";
import styles from "./index.less?module";

const ShareLinkDetail = {
  data() {
    return {
      linkId: undefined,
      formVal: {
        portfolioName: "-",
        shareProfitPercent: "- %",
        settlementPeriodTypeName: "-",
        currentSettlementEndTime: "-",
        following: "- %",
        maxVolume: "-",
        symbols: "-",
        account: "-",
        server: "-",
        equity: "-",
        balance: "-",
        profit: "-",
        autoRecon: undefined,
        agreeActivation: undefined,
      },
    };
  },
  computed: {
    ...mapState([]),
  },
  mounted() {
    this.getBaseInfo();
  },
  created() {},
  methods: {
    // 获取信号源基本信息
    getBaseInfo() {
      const loading = this.$loading({
        lock: true,
      });
      this.$axios
        .get("/api/Portfolio/ShareLinkDetail", {
          params: { code: this.$route.query.code },
        })
        .then((res) => {
          const { isSuccess, result } = res.data;

          if (isSuccess) {
            this.formVal = omit(result, [
              "id",
              "forexSelect",
              "energySelect",
              "metalsSelect",
              "indicesSelect",
              "cryptoSelect",
              "following",
              "shareProfitPercent",
            ]);
            this.linkId = result.id;
            this.formVal.following = `${result.following} %`;
            this.formVal.shareProfitPercent = `${result.shareProfitPercent} %`;
            this.formVal.symbols = `${
              result.forexSelect ? this.$t("Common_Fx") : ""
            } ${result.energySelect ? this.$t("Common_Energy") : ""} ${
              result.metalsSelect ? this.$t("Common_Metal") : ""
            } ${result.indicesSelect ? this.$t("Common_Indices") : ""} ${
              result.cryptoSelect ? this.$t("Common_Crypto") : ""
            }`;
          }
        })
        .finally(() => {
          loading.close();
        });
    },
    goBackHome() {
      this.$router.push({ path: "/HomeIndex" });
    },

    followSignal() {
      this.$refs.followSignalDrawer.open();
    },
  },

  render() {
    const colSpan = isMobile ? 24 : 12;

    return (
      <div class="PageCommon">
        <div class={{ tableDiv: !isMobile, [styles.h5Container]: isMobile }}>
          {!isMobile && (
            <div class="pageTitle">{this.$t("SignalSource_Detail")}</div>
          )}
          <Form
            ref="shareLinkDetailForm"
            labelPosition="top"
            props={{ model: this.formVal }}
            class={styles.shareLinkDetailForm}
          >
            <Row gutter={30}>
              {/* 信号名称 */}
              <Col span={colSpan}>
                <FormItem label={this.$t("Signal_Name")} prop="portfolioName">
                  <Input v-model={this.formVal.portfolioName} disabled />
                </FormItem>
              </Col>
              {/* 支付分润比例 */}
              <Col span={colSpan}>
                <FormItem
                  label={this.$t("Common_TableTitle_PLSharingRatio")}
                  prop="shareProfitPercent"
                >
                  <Input v-model={this.formVal.shareProfitPercent} disabled />
                </FormItem>
              </Col>
            </Row>
            <Row gutter={30}>
              {/* 结算周期 */}
              <Col span={colSpan}>
                <FormItem
                  label={this.$t("Common_TableTitle_SignalSettlementCycle")}
                  prop="settlementPeriodTypeName"
                >
                  <Input
                    v-model={this.formVal.settlementPeriodTypeName}
                    disabled
                  />
                </FormItem>
              </Col>
              {/* 初始结算 */}
              <Col span={colSpan}>
                <FormItem
                  label={this.$t("ViewInvitation_FirstSettlementTime")}
                  prop="currentSettlementEndTime"
                >
                  <Input
                    v-model={this.formVal.currentSettlementEndTime}
                    disabled
                  />
                </FormItem>
              </Col>
            </Row>
            <Row gutter={30}>
              {/* 跟单比例 */}
              <Col span={colSpan}>
                <FormItem
                  label={this.$t("Common_TableTitle_CopyRatio")}
                  prop="following"
                >
                  <Input v-model={this.formVal.following} disabled />
                </FormItem>
              </Col>
              {/* 最大交易量 */}
              <Col span={colSpan}>
                <FormItem
                  label={this.$t("Common_TableTitle_MaxLot")}
                  prop="maxVolume"
                >
            
                   <Input value={this.formVal.maxVolume == 0 ? this.$t("Common_TR_VolumeNotLimit") : this.formVal.maxVolume} disabled />
                </FormItem>
              </Col>
            </Row>
            <Row gutter={30}>
              {/* 交易对 */}
              <Col span={24}>
                <FormItem
                  label={this.$t("Common_TableTitle_Instruments")}
                  prop="symbols"
                >
                  <Input v-model={this.formVal.symbols} disabled />
                </FormItem>
              </Col>
            </Row>
            <Row gutter={30}>
              {/* 信号账户 */}
              <Col span={colSpan}>
                <FormItem
                  label={this.$t("Common_TableTitle_Mt4Account")}
                  prop="account"
                >
                  <Input v-model={this.formVal.account} disabled />
                </FormItem>
              </Col>
              {/* 服务器 缺字段*/}
              <Col span={colSpan}>
                <FormItem label={this.$t("Common_Mt4Server")} prop="serverName">
                  <Input v-model={this.formVal.server} disabled />
                </FormItem>
              </Col>
            </Row>
            <Row gutter={30}>
              {/* 净值 */}
              <Col span={colSpan}>
                <FormItem
                  label={this.$t("Common_TableTitle_Equity")}
                  prop="equity"
                >
                  <Input v-model={this.formVal.equity} disabled />
                </FormItem>
              </Col>
              {/* 余额 */}
              <Col span={colSpan}>
                <FormItem
                  label={this.$t("Common_TableTitle_Balance")}
                  prop="balance"
                >
                  <Input v-model={this.formVal.balance} disabled />
                </FormItem>
              </Col>
            </Row>
            <Row gutter={30}>
              {/* 盈亏 */}
              <Col span={colSpan}>
                <FormItem
                  label={this.$t("Common_TableTitle_ProfitLoss")}
                  prop="profit"
                >
                  <Input
                    v-model={this.formVal.profit}
                    disabled
                    class={[
                      this.formVal.profit > 0
                        ? "greenNum"
                        : this.formVal.profit < 0
                        ? "redNum"
                        : "",
                      "mobileTableContent",
                    ]}
                  />
                </FormItem>
              </Col>
            </Row>
            <Row gutter={30}>
              {/* 自动补单 */}
              <Col span={colSpan}>
                <FormItem
                  label={this.$t("Common_TableTitle_AutoMatchOrder")}
                  prop="autoRecon"
                >
                  <RadioGroup v-model={this.formVal.autoRecon} disabled>
                    <Radio label={true}>{this.$t("Common_Yes")}</Radio>
                    <Radio label={false}>{this.$t("Common_No")}</Radio>
                  </RadioGroup>
                </FormItem>
              </Col>
              {/* 激活状态 */}
              <Col span={colSpan}>
                <FormItem
                  label={this.$t("Common_TableTitle_ActivationStatus")}
                  prop="agreeActivation"
                >
                  <RadioGroup v-model={this.formVal.agreeActivation} disabled>
                    <Radio label={true}>{this.$t("Common_Yes")}</Radio>
                    <Radio label={false}>{this.$t("Common_No")}</Radio>
                  </RadioGroup>
                </FormItem>
              </Col>
            </Row>

            <div class={styles.formButtonGroup}>
              {/* 跟随 */}
              <Button class="confirmDialogBtn" onClick={this.followSignal}>
                {this.$t("Menu_Followers")}
              </Button>
              {/* 返回首页 */}
              <Button class="cancelDialogBtn" onClick={this.goBackHome}>
                {this.$t("Back_Home")}
              </Button>
            </div>
          </Form>
        </div>
        <FollowSignalDrawer ref="followSignalDrawer" linkId={this.linkId} />
      </div>
    );
  },
};

export default ShareLinkDetail;
